export default "__VITE_ASSET__Cl3wDNWZ__"